import './App.sass';
import "@fontsource/poppins";
import "@fontsource/source-code-pro";

import { Route, Routes, useNavigate } from "react-router-dom";

import Login from "../Login/Login";
import Register from "../Register/Register";
import Home from "../Home/Home";
import Reset from "../Reset/Reset";
import Profile from "../Profile/Profile";
import NotFound from "../NotFound/NotFound";
import logo from "../../images/hume-logo.png";

const App = () => {
  const navigate = useNavigate();

  return (
    <div className="App">
      <div className="App-header">
        <img src={logo} className="App-logo" alt="logo" onClick={() => navigate("/home")} />
      </div>
      <div className="App-content">
        <Routes>
          <Route path="/" element={<Login />}></Route>
          <Route path="/home" element={<Home />}></Route>
          <Route path="/register" element={<Register />} />
          <Route path="/reset" element={<Reset />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="*" element={<NotFound />}></Route>
        </Routes>
      </div>
    </div>
  );
};

export default App;